import { render, staticRenderFns } from "./AdminCommissionRates.vue?vue&type=template&id=619a258f&scoped=true&"
import script from "./AdminCommissionRates.vue?vue&type=script&lang=js&"
export * from "./AdminCommissionRates.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommissionRates.vue?vue&type=style&index=0&id=619a258f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a258f",
  null
  
)

export default component.exports